import brLocale from 'date-fns/locale/pt-BR';
import enLocale from 'date-fns/locale/en-US';

export const getLocaleAdapterReducer = (locale: string) => {
    switch (locale) {
        case 'pt-BR':
            return brLocale;
        case 'en-US':
            return enLocale;
        default:
            return enLocale;
    }
}

export const getFormCurrencyLocationConfig = (locale: string) => {
    switch (locale) {
        case 'pt-BR':
            return {
                valueIsNumericString: true,
                fixedDecimalScale: true,
                decimalScale: 2,
                decimalSeparator: ',',
                thousandSeparator: '.',
            };
        case 'en-US':
            return {
                valueIsNumericString: true,
                fixedDecimalScale: true,
                decimalScale: 2,
                decimalSeparator: '.',
            };
        default:
            return {
                valueIsNumericString: true,
                fixedDecimalScale: true,
                decimalScale: 2,
                decimalSeparator: '.',
            };
    }
}

export const generatePassword = (): string => {
    const length = 12;
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()-_=+[]{}|;:,.<>?';

    const allChars = lowercase + uppercase + numbers + symbols;

    // Ensure at least one character from each required set
    const getRandom = (chars: string) => chars[Math.floor(Math.random() * chars.length)];
    let password = [
        getRandom(lowercase),
        getRandom(uppercase),
        getRandom(numbers),
        getRandom(symbols)
    ];

    // Fill the rest of the password
    for (let i = password.length; i < length; i++) {
        password.push(getRandom(allChars));
    }

    // Shuffle the password to avoid predictable positions
    for (let i = password.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [password[i], password[j]] = [password[j], password[i]];
    }

    return password.join('');
};